'use strict';

const get = require('lodash/get');

const PlacePreviewDrawer = require('../../offers_map_preview_drawer/frontend/place_preview_drawer');

const MarkerTooltip = require('./marker_tooltip');

module.exports = (function() {
  class PlaceCard {
    static initClass() {
      this.prototype.rootUrl = '/merchant-page/offers-map';
      this.prototype.config = null;
      this.prototype.offersMap = null;
      this.prototype.place = null;
      this.prototype.map = null;
      this.prototype.label = null;
      this.prototype.$placePreview = null;
      this.prototype.$el = null;
      this.prototype.$marker = null;
      this.prototype.$tooltip = null;
      this.prototype.$mapContainer = null;
      this.prototype.templates = {
        placeCard: require('../place_card.html.mustache'),
        mapMarker: require('../map_marker.html.mustache'),
        tooltip: require('../tooltip.html.mustache'),
        previewDrawer: require('../../offers_map_preview_drawer/main.html.mustache'),
      };
    }

    constructor({
      offersMap,
      place,
      map,
      label,
      $placePreview,
      config,
      history,
    }) {
      this.cardClick = this.cardClick.bind(this);
      this.markerClick = this.markerClick.bind(this);
      this.dotClick = this.dotClick.bind(this);
      this.mouseEnter = this.mouseEnter.bind(this);
      this.mouseLeave = this.mouseLeave.bind(this);
      this.offersMap = offersMap;
      this.place = place;
      this.map = map;
      this.label = label;
      this.$placePreview = $placePreview;
      this.config = config;
      this.history = history;
      this.$mapContainer = this.offersMap.$el.find('.map-container');
    }

    placeTemplateData() {
      const data = {};

      data.translate = data.t = () => str => I18n.t(str);

      return _.extend(data, this.place, {
        label: this.label,
        name: this.place.name,
        hasDeals: this.hasDeals(),
        formattedLocation: this.getFormattedLocation(),
        translations: {
          recommendations: this.getRecommendationsString(),
          numberOfOffers: this.getNumberOfOffersString(),
        },
      });
    }

    render() {
      this.$el = $(this.templates.placeCard.render(this.placeTemplateData()));
      this.$el.click(this.cardClick);
      this.$el.hover(this.mouseEnter, this.mouseLeave);
      return this.$el;
    }

    isPlacePreviewShowingThisPlace() {
      return (
        this.place.uuid ===
          get(this.offersMap.placePreviewDrawer, 'place.uuid', undefined) &&
        this.offersMap.placePreviewDrawer.isVisible()
      );
    }

    getFormattedLocation() {
      if (this.place.location.streetAddress == null) {
        return null;
      } // Remove the period at the end of some addresses ("123 10th St.", for example)

      let formattedLocation = this.place.location.streetAddress.replace(
        /\.$/,
        ''
      ); // Remove the street number

      if (I18n.country === 'US') {
        formattedLocation = formattedLocation.replace(/^[0-9]+ /, '');
      }

      return formattedLocation;
    }

    isOpenNow() {
      return (
        (this.place.formattedHours != null
          ? this.place.formattedHours.openNow
          : undefined) === true
      );
    }

    hasDeals() {
      return get(this.place, 'offers.deal.items', undefined).length > 0;
    }

    getNumberOfOffersString() {
      if (this.place.offers == null) {
        return null;
      }

      const count =
        ((this.place.offers.deal != null
          ? this.place.offers.deal.total
          : undefined) != null
          ? this.place.offers.deal != null
            ? this.place.offers.deal.total
            : undefined
          : 0) +
        ((this.place.offers.coupon != null
          ? this.place.offers.coupon.total
          : undefined) != null
          ? this.place.offers.coupon != null
            ? this.place.offers.coupon.total
            : undefined
          : 0);

      if (!(count > 0)) {
        return null;
      }

      return I18n.t('js.modules.offers_map.place_card.number_of_offers', {
        count,
      });
    }

    getRecommendationsString() {
      if (
        get(this.place.ugc, 'recommendation.showToUser', undefined) !== true
      ) {
        return null;
      }

      const { total, percentage } = this.place.ugc.recommendation;
      return I18n.t('js.modules.offers_map.place_card.recommendations', {
        total,
        percentage,
      });
    }

    addMarker() {
      if (this.map == null) {
        return null;
      }

      const labelLength =
        this.label && this.label.toString() && this.label.toString().length;
      const data = {
        uuid: this.place.uuid,
        label: this.label,
        labelLength: {
          two: labelLength === 2,
          three: labelLength === 3,
          fourPlus: labelLength >= 4,
        },
        tooltipHtml: this.templates.tooltip.render(this.placeTemplateData()),
        bhc: {
          marker: `place-map-pin:${this.place.uuid}`,
          dot: `place-map-dot:${this.place.uuid}`,
        },
      };
      this.$marker = $(this.templates.mapMarker.render(data));

      if (this.config.showDrawer === true) {
        this.$marker.find('.marker-label').addClass('default-cursor');
      }

      this.$tooltip = this.$marker.find('.marker-tooltip');
      const $label = this.$marker.find('.marker-label');
      $label.click(this.markerClick);
      $label.hover(this.mouseEnter, this.mouseLeave);
      const $dot = this.$marker.find('.marker-dot');
      $dot.click(this.dotClick);
      $dot.hover(this.mouseEnter, this.mouseLeave);
      this.marker = new RichMarker({
        position: new google.maps.LatLng(
          this.place.location.lonLat.lat,
          this.place.location.lonLat.lon
        ),
        map: this.map,
        draggable: false,
        shadow: false,
        content: this.$marker[0],
      });
      this.tooltip = new MarkerTooltip({
        marker: this.marker,
        $hoverElement: this.$el.add($label).add($dot),
        $mapContainer: this.$mapContainer,
        $tooltip: this.$tooltip,
        $marker: this.$marker,
      });
      return this.tooltip;
    }

    openPlacePage() {
      window.location = `/biz/${this.place.slug}`;
      return window.location;
    }

    cardClick() {
      if (this.config.showDrawer === false) {
        return this.openPlacePage();
      }

      if (
        !this.offersMap.isDesktopView() &&
        !this.offersMap.$offersMap.hasClass('fullscreen')
      ) {
        this.offersMap.fullscreenHandler();
      }

      this.offersMap.removeAllPlaceCardHighlights();
      this.highlight();
      return this.showPreview();
    }

    markerClick() {
      if (this.config.showDrawer === false) {
        return this.openPlacePage();
      }
      return null;
    }

    dotClick() {
      this.offersMap.removeAllPlaceCardHighlights();
      this.highlight();
      return this.scrollToCard();
    }

    hidePreview(saveInHistory = true) {
      this.removeHighlight();

      if (this.offersMap.placePreviewDrawer != null) {
        this.offersMap.placePreviewDrawer.hide({
          saveInHistory,
        });
      }

      this.offersMap.placePreviewDrawer = null;
      return this.offersMap.placePreviewDrawer;
    }

    showPreviewFromHistory() {
      this.offersMap.removeAllPlaceCardHighlights();
      this.highlight();
      return this.showPreview(false);
    }

    showPreview(saveInHistory = true) {
      if (this.isPlacePreviewShowingThisPlace()) {
        return this.hidePreview(saveInHistory);
      }

      this.offersMap.$offersMap.addClass('show-preview-drawer');
      this.offersMap.placePreviewDrawer = new PlacePreviewDrawer({
        offersMap: this.offersMap,
        $el: this.$placePreview,
        place: this.place,
      });
      this.offersMap.placePreviewDrawer.onceOnClose(data => {
        this.removeHighlight();
        this.offersMap.$offersMap.removeClass('show-preview-drawer');

        if ((data != null ? data.saveInHistory : undefined) !== false) {
          return this.history.add({
            action: 'place-preview-hide-modal',
            placeId: this.place.uuid,
          });
        }
        return null;
      });

      if (saveInHistory !== false) {
        return this.history.add({
          action: 'place-preview-show-modal',
          placeId: this.place.uuid,
        });
      }
      return null;
    }

    highlight() {
      return this.$el.addClass('highlight');
    }

    removeHighlight() {
      return this.$el != null ? this.$el.removeClass('highlight') : undefined;
    }

    scrollToCard() {
      if (this.offersMap.isUsingHorizontalScrolling()) {
        const cardWidth = this.$el.outerWidth();
        const scrollLeft = cardWidth * this.label - cardWidth;
        return this.offersMap.$cardsOverflow.animate(
          {
            scrollLeft,
          },
          500
        );
      } else {
        const cardHeight = this.$el.outerHeight();
        const scrollTop = cardHeight * this.label - cardHeight;
        return this.offersMap.$cards.animate(
          {
            scrollTop,
          },
          500
        );
      }
    }

    showImage() {
      return this.$el.removeClass('hide-image');
    }

    showDot() {
      return this.$marker.addClass('show-dot');
    }

    showPin() {
      return this.$marker.removeClass('show-dot');
    } // This is used when hovering over either the Marker or the Card.

    mouseEnter() {
      this.$el.addClass('active');

      if (this.$marker != null) {
        return this.$marker.find('.marker-label').addClass('active');
      }
      return null;
    }

    mouseLeave() {
      this.$el.removeClass('active');

      if (this.$marker != null) {
        return this.$marker.find('.marker-label').removeClass('active');
      }
      return null;
    }

    destroy() {
      if (this.$marker != null) {
        this.$marker.remove();
      }

      if (this.$el != null) {
        this.$el.remove();
      }

      return this.marker != null ? this.marker.setMap(null) : undefined;
    }
  }
  PlaceCard.initClass();
  return PlaceCard;
})();
